import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-not-available',
  templateUrl: './not-available.component.html',
  styleUrls: ['./not-available.component.scss'],
  standalone: false,
})
export class NotAvailableDialogComponent {
  private dialog =
    inject<MatDialogRef<NotAvailableDialogComponent>>(MatDialogRef);
  dialogData = inject(MAT_DIALOG_DATA);
}
